import { render, staticRenderFns } from "./dadosNotaEntradaLote.vue?vue&type=template&id=05180f20"
import script from "./dadosNotaEntradaLote.ts?vue&type=script&lang=js&external"
export * from "./dadosNotaEntradaLote.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/1/s/TafStore.PharmUP.Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('05180f20')) {
      api.createRecord('05180f20', component.options)
    } else {
      api.reload('05180f20', component.options)
    }
    module.hot.accept("./dadosNotaEntradaLote.vue?vue&type=template&id=05180f20", function () {
      api.rerender('05180f20', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/parent/crud/produtolote/dadosNotaEntradaLote.vue"
export default component.exports